import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { DataTablesModule } from 'angular-datatables';
import { HighchartsChartModule } from 'highcharts-angular';
import { BaseChartDirective } from 'ng2-charts';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from 'src/app/shared/shared.module';
import { AuditTrailModule } from './AuditTrail/audit-trail.module';
import { ComplainceAdminRoutingModule } from './complainceAdmin-routing.module';
import { DigitalSignatureComponent } from './digital-signature/digital-signature.component';
import { EnitComplainceRoutingModule } from './eComplaince-routing.module';
import { EnitComplainceModule } from './EnitCompliance/compliance.module';
import { InternalAuditModule } from './EnitCompliance/InternalAudit/internal-audit.module';
import { CtclModule } from './EnitTrade/ctcl/ctcl.module';
import { EnitTradeModule } from './EnitTrade/trade.module';
import { EnitRoutingModule } from './eTrade-routing.module';
import { TradeAdminRoutingModule } from './tradeAdmin-routing.module';
import { CyberSecurityAuditModule } from './EnitCompliance/CyberSecurityAudit/cyber-security-audit.module';
import { AnnualComplianceAuditReportModule } from './EnitCompliance/AnnualComplianceAuditReport/annual-compliance-audit-report.module';

@NgModule({
  declarations: [
    DigitalSignatureComponent,
  ],
  imports: [
    CommonModule,
    EnitRoutingModule, 
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    SharedModule,
    EnitComplainceModule,
    CtclModule,
    AgGridModule,
    TradeAdminRoutingModule,
    ComplainceAdminRoutingModule,
    HighchartsChartModule,
    InternalAuditModule,
    EnitTradeModule,
    // BaseChartDirective,
    AuditTrailModule,
    CyberSecurityAuditModule,
    AnnualComplianceAuditReportModule,
    
  ]
})
export class EnitModule {}
